module.exports = __webpack_public_path__ + "static/media/lunchSelected.ad9e9b1d.png";